/* eslint-disable import/prefer-default-export,import/no-unresolved */
import React, { useMemo, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MAIN_ICON_COLORS } from 'assets/components';
import { onboardingScreens } from '../constants';
import Icon from '../../../../components/Icon';
import { ICONS } from '../../../../components/Icon/constants';
import { OnboardingContext } from '../../../../contexts/onboarding/context';

export const OnboardingRegistrationSteps = () => {
  const { t: translate } = useTranslation();

  const { state, updateSignupSteps } = useContext(OnboardingContext);

  const currentScreen = state?.currentScreen;
  const signupSteps = state?.signupSteps;

  const steps = useMemo(
    () => [
      {
        id: 1,
        label: translate('email_verification_title'),
        name: onboardingScreens.CONFIRM_EMAIL,
        icon: ICONS.ENVELOPE,
        iconName: 'envelope',
        active: currentScreen === onboardingScreens.CONFIRM_EMAIL,
        completed: signupSteps[onboardingScreens.CONFIRM_EMAIL].checked,
      },
      {
        id: 2,
        label: translate('onboarding_confirm_phone_number_step_label'),
        name: onboardingScreens.ADD_PHONE_NUMBER,
        icon: ICONS.PHONE,
        iconName: 'phone',
        active:
          currentScreen === onboardingScreens.ADD_PHONE_NUMBER ||
          currentScreen === onboardingScreens.CONFIRM_PHONE_NUMBER,
        completed: signupSteps[onboardingScreens.CONFIRM_PHONE_NUMBER].checked,
      },
      {
        id: 2,
        name: onboardingScreens.CONFIRM_PHONE_NUMBER,
        hidden: true,
      },
      {
        id: 3,
        label: translate('onboarding_personal_info_step_label'),
        name: onboardingScreens.ADD_PERSONAL_INFO,
        icon: ICONS.USER_PLUS,
        iconName: 'info',
        active: currentScreen === onboardingScreens.ADD_PERSONAL_INFO,
        completed: signupSteps[onboardingScreens.ADD_PERSONAL_INFO].checked,
      },
      {
        id: 4,
        label: translate('onboarding_additional_personal_info_step_label'),
        name: onboardingScreens.ADDITIONAL_PERSONAL_DETAILS,
        icon: ICONS.USER_PLUS,
        iconName: 'info',
        active: currentScreen === onboardingScreens.ADDITIONAL_PERSONAL_DETAILS,
        completed: signupSteps[onboardingScreens.ADDITIONAL_PERSONAL_DETAILS].checked,
      },
      {
        id: 5,
        label: translate('onboarding_physical_address_step_label'),
        name: onboardingScreens.ADD_PHYSICAL_ADDRESS,
        icon: ICONS.ADDRESS,
        iconName: 'address',
        active:
          currentScreen === onboardingScreens.ADD_PHYSICAL_ADDRESS ||
          currentScreen === onboardingScreens.ADD_MAILING_ADDRESS,
      },
      {
        id: 5,
        name: onboardingScreens.ADD_MAILING_ADDRESS,
        hidden: true,
      },
      {
        id: 6,
        label: translate('onboarding_verify_identity_step_label'),
        name: '',
        icon: ICONS.SCAN,
        iconName: 'scan-other',
        active: false,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentScreen, signupSteps]
  );

  const checkCompletedSteps = () => {
    const currentStepObj = steps.find((step) => step.name === currentScreen);

    if (currentStepObj) {
      const currentStepNumber = currentStepObj.id;
      steps.forEach((step) => {
        if (step.id < currentStepNumber) {
          updateSignupSteps(step.name, true);
        }
      });
    }
  };

  useEffect(() => {
    if (steps) {
      checkCompletedSteps();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentScreen]);

  return (
    <div className="d-flex letter-spacing-sm px-md-3 justify-content-center justify-content-md-start">
      <div className="d-flex flex-column justify-content-center ps-4 mt-3 mt-md-4 pe-3 pe-md-0 pt-md-3">
        <p className="text-dark text-bold text-f3">
          {translate('onboarding_registeration_steps_title')}
        </p>
        <div className="mt-4 pt-3">
          {steps
            ?.filter((step) => !step.hidden)
            .map((step, index) => (
              <div key={step?.id} className="d-flex flex-column">
                <div className="d-flex flex-row justify-content-start">
                  <div className="d-flex flex-column align-items-center">
                    <div
                      className={`d-flex justify-content-center align-items-center border border-1 p-3 rounded-xl ${
                        step?.active ? 'border-primary' : 'border-disabled'
                      } ${step?.completed ? 'bg-primary' : ''}`}
                      style={{ width: '3.5rem', height: '3.5rem' }}>
                      {step?.icon && !step?.completed && (
                        <Icon
                          icon={step.icon}
                          color={step?.active ? MAIN_ICON_COLORS.PRIMARY : MAIN_ICON_COLORS.SHADOW}
                        />
                      )}
                      {step?.completed && (
                        <Icon icon={ICONS.CHECK} color={MAIN_ICON_COLORS.WHITE} />
                      )}
                    </div>
                    {index !== steps.filter((item) => !item.hidden).length - 1 && (
                      <div
                        className="my-2 border border-1 border-disabled"
                        style={{ height: '2rem', width: '1px' }}
                      />
                    )}
                  </div>
                  <div className="d-flex flex-column ms-4 mt-2">
                    <p
                      className={`text-f6 text-uppercase ${
                        step?.active ? 'text-primary' : 'text-shadow'
                      }`}>
                      {translate('onboarding_step_label').replace('__NUM__', step.id)}
                    </p>
                    <p
                      className={`text-f5 text-bold mt-1 ${
                        step?.active ? 'text-dark' : 'text-shadow'
                      }`}>
                      {step.label}
                    </p>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
